<div class="app-wrapper">
  <app-header />
  <app-system-message></app-system-message>
  <ng-container *ngIf="dbReady(); else loading">
    <router-outlet />
  </ng-container>
  <ng-template #loading>
    <div class="db-loading">
      <p *ngIf="!dbError()">Initialisiere lokale Datenbank ...</p>
      <p *ngIf="dbError()" style="color:red;">{{ dbError() }}</p>
    </div>
  </ng-template>
  <app-footer />
</div>
